import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import Image from '../components/Image';
import {
  doAddFavorite,
  doDeleteFavorite ,
  openLoginFormRequest,
} from '../actions';
import isLoggedIn, { objectToFormData } from '../utils/index';
import TextareaAutosize from 'react-autosize-textarea';
import OrganizationFavBtn from './OrganizationFavBtn';


class OrganizationCard extends Component {
  state = {
    showEditBox: false,
    content: null,
    favoriteAction: 'add'
  };

  constructor(props) {
    super(props);
    this.state = {
      content: props.item.thumbnail_text
    };
  }

  showEditBox = e => {
    e.preventDefault();
    this.setState({ showEditBox: true });
  };

  hideEditBox = e => {
    e.preventDefault();
    this.setState({ showEditBox: false });
  };

  cancelEdit = e => {
    this.setState({ content: null });
    this.hideEditBox(e);
  };

  updateContent = e => {
    this.setState({ content: e.target.value });
  };

  saveContent = e => {
    e.preventDefault();
    this.props.updateContent('thumbnail_text', this.state.content);
    this.hideEditBox(e);
  };

  handleAddFavorite = e => {
    alert(1)
    console.info('->->->->', this.props)
    if(!isLoggedIn(this.props.auth.user)) {
      return this.props.openLoginFormRequest();
    }
    e.preventDefault();
    this.props.doAddFavorite(objectToFormData({
      organization: this.props.item.db_id
    }));
    this.setState({ favoriteAction: 'delete' });
  };

  handleDeleteFavorite = e => {
    if(!isLoggedIn(this.props.auth.user)) {
      return this.props.openLoginFormRequest();
    }
    e.preventDefault();
    this.props.doDeleteFavorite({
      id: this.props.item.db_id
    });
    this.setState({ favoriteAction: 'add' });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.item.db_id != this.props.item.db_id) {
      this.setState({ content: nextProps.item.thumbnail_text})
    }
  }
  componentWillMount() {
    this.setState({ content: this.props.item.thumbnail_text})
  }

  render() {
    const item = this.props.item;
    const { user } = this.props.auth;
    const coverImageSrc = `thumbnails/?model=organization&id=${item.db_id}&size=600x225&source=image_cover`;
    const iconImageSrc = `thumbnails/?model=organization&id=${item.db_id}&size=75x75&source=image_icon`;

    let categoryName = '';
    if(item.category_names) {
      categoryName = item.category_names[item.category_names.length - 1];
    }

    let regionName = '';
    //Tests for location hierarchy
    if (item.is_global) {
      regionName = 'Global access';
    }
    else if (item.is_online) {
      regionName = 'Online access';
    } else if (item.is_national) {
      regionName = item.region_names[0];
    } else if (item.is_state) {
      regionName = item.region_names[1];
    } else {
      if (item.region_names && item.region_names.length !== undefined && item.region_names.length != 0) {


        regionName = item.region_names[item.region_names.length - 1];

        if (regionName.length == 3) {

          regionName = item.region_names[item.region_names.length - 2] + ', ' + regionName;
        }

      }
    }

    const favFormRef = `favForm${item.db_id}`;
    const orgAbsUrl = `/organizations/${item.db_id}/${item.slug}`;

    let editIcon = '';
    if(this.props.isEditMode) {
      editIcon = <div className="organizationDetail-editThumbnailTextIcon-wrapper"><span onClick={this.showEditBox} className="organizationDetail-editThumbnailTextIcon">
        <i className="fa fa-pencil"></i> Edit
      </span></div>;
    }

    let thumbnailText = this.state.content

    let editBox = '';
    if(this.state.showEditBox) {
      editBox = <span className="organizationDetail-thumbnailTextEditBox">
        <div className="">
          <button onClick={this.saveContent} className="button-primary">Save</button>&nbsp;
          <button onClick={this.cancelEdit} className="">Cancel</button>
        </div>
        <TextareaAutosize onChange={this.updateContent} defaultValue={thumbnailText} />
      </span>;
    }

    let favButton = <button className="btn-heart btn-heartOff" onClick={this.handleAddFavorite} type="submit"><i className="fa fa-heart-o" aria-hidden="true"></i>
</button>;
    if(this.state.favoriteAction == 'delete') {
      favButton = <button className="btn-heart btn-heartOn" onClick={this.handleDeleteFavorite} type="submit"><i className="fa fa-heart" aria-hidden="true"></i>
</button>;
    }

    if(user) {
      let favOrgs = [];
      favOrgs = user.favorites.map(fav => {
        return fav.organization;
      });


      if(favOrgs.indexOf(item.db_id) != -1) {
        favButton = <button className="btn-heart btn-heartOn" onClick={this.handleDeleteFavorite} type="submit"><i className="fa fa-heart" aria-hidden="true"></i></button>;
      }
    }



    return (
      <div className="organizationCard">
        <Link to={orgAbsUrl} onClick={(e) => { if (this.props.isEditMode) { e.preventDefault(); }}}>
          <div className="organizationCardBody">
            <Image className="organizationCard-coverImage" src={coverImageSrc} />
            <Image className="organizationCard-iconImage" src={iconImageSrc} />
            <div className="organizationCard-name textblock-ellipsis">{item.name}</div>
            <div className="organizationCard-thumbnailText textblock-ellipsis">
              {thumbnailText}
            </div>
          </div>
        </Link>
          {editIcon}
          {editBox}


        <div className="organizationCard-bottomBand">
          <div className="organizationCard-bottomBand-left">
            <div className="organizationCard-category"><i className="fa fa-home"></i> {categoryName}</div>
            <div className="organizationCard-region"><i className="fa fa-map-marker"></i>{regionName}</div>
          </div>
          <div className="organizationCard-favoriteForm">

            <OrganizationFavBtn
              routing={this.props.routing}
              browser={this.props.browser}
              auth={this.props.auth}
              db_id={this.props.db_id}
            />

          </div>
        </div>
      </div>
    );
  }


};


function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    doDeleteFavorite,
    doAddFavorite
  }
)(OrganizationCard);



// WEBPACK FOOTER //
// ./src/components/OrganizationCard.jsx